export const formatStationWorkingTimeTime = (value: string): string => {
  const digits = value.replace(/\D/g, "");
  if (digits.length >= 4) return digits.slice(0, 4);
  return digits.padStart(4, "0");
};
